import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        version: '1.0.4',
        navAppTitle: 'Catabocata',
        navMainLogo: require('@/assets/catabocata2.png'),
        bWaitCursor: false,
        bNoResults: false, //Indica si no hubo resultados en una búsqueda de productos.
        bAutorizado: null,

        //Vinatería:
        selectedWineIndex: -1, //Indice del vino seleccionado en la ventana Vinateria.
        vino: {
            nombre: '',
            tipo: '',
            uva: '',
            region: '',
            pais: '',
            bodega: '',
            descripcion: '',
            notasdecata: '',
            imagen: '',
            rating: 0,
        },

        //Licorería:
        selectedLiquorIndex: -1, //Indice del producto seleccionado en la ventana Licorería.
        licor: {
            nombre: '',
            tipo: '',
            pais: '',
            descripcion: '',
            etiqueta: '',
            imagen: '',
            rating: 0,
        },

        //Cervecería:
        selectedBeerIndex: -1, //Indice del producto seleccionado en la ventana Cervecería.
        cerveza: {
            nombre: '',
            tipo: '',
            pais: '',
            descripcion: '',
            etiqueta: '',
            imagen: '',
            rating: 0,
        },

        paises: [],
        tiposVinos: [],
        tiposLicores: [],
        tiposCervezas: [],
        vinos: [],
        licores: [],
        cervezas: [],
        // vinosTemp: [
        //     {
        //         vinoid: 1,
        //         nombre: 'Monteviña',
        //         bodega: 'Vinícola San Lorenzo',
        //         tipo: 'Tinto',
        //         pais: 'México',
        //         region: 'Valle de Parras',
        //         uva: 'Cabernet Sauvignon-Merlot',
        //         descripcion: 'Vino tinto joven, fermentado en tanques de acero inoxidable, usando el método francés Délestage.',
        //         notasdecata: 'De color rojo cereza. Vino expresivo de aromas francos y limpios, frutos rojos como fresa, grosella, frambuesa y unas notas de rosas y vainilla.',
        //         imagen: require("@/assets/vinateria/montevina.png"),
        //         rating: 4.5
        //     },
        //     {
        //         vinoid: 2,
        //         nombre: 'Vino Tinto Ruby Dulce',
        //         bodega: 'Viñedos La Redonda',
        //         tipo: 'Tinto',
        //         pais: 'México',
        //         region: 'Querétaro',
        //         uva: 'Ruby Cabernet',
        //         descripcion: 'Vino tinto dulce de maduración tardía. Fermentado a baja temperatura para guardar características propias del fruto.',
        //         notasdecata: 'Rojo granate intenso y muy profundo con matices violáceos. Frutos secos como ciruela pasa, higo y especiados como canela. Ataque suave, acidez delicada dulce, cuerpo medio con buen equilibrio.',
        //         imagen: require("@/assets/vinateria/la_redonda.png"),
        //         rating: 3.5
        //     },
        // ],
        platillos: [],
        productosGourmet: []

    },
    mutations: {
        setAutorizado(state, autorizado) {
            state.bAutorizado = autorizado;
            if (state.bAutorizado) {
                router.push('/');
            }
        },
        setNoResults(state, payload) {
            state.bNoResults = payload;
        },
        setPaises(state, paises) {
            state.paises = paises;
            //Se agregan dos elementos al principio, para poder seleccionar "Todos" y "Seleccione" en el Select:
            state.paises.unshift({
                paisid: 0,
                pais: 'Todos'
            });
            state.paises.unshift({
                paisid: -1,
                pais: 'Seleccione'
            });
        },
        setTiposVinos(state, tiposVinos) {
            state.tiposVinos = tiposVinos;
            //Se agregan dos elementos al principio, para poder seleccionar "Todos" y "Seleccione" en el Select:
            state.tiposVinos.unshift({
                tipoid: 0,
                tipo: 'Todos'
            });
            state.tiposVinos.unshift({
                tipoid: -1,
                tipo: 'Seleccione'
            });
        },
        setTiposLicores(state, tiposLicores) {
            state.tiposLicores = tiposLicores;
            //Se agregan dos elementos al principio, para poder seleccionar "Todos" y "Seleccione" en el Select:
            state.tiposLicores.unshift({
                tipoid: 0,
                tipo: 'Todos'
            });
            state.tiposLicores.unshift({
                tipoid: -1,
                tipo: 'Seleccione'
            });
        },
        setTiposCervezas(state, tiposCervezas) {
            state.tiposCervezas = tiposCervezas;
            //Se agregan dos elementos al principio, para poder seleccionar "Todos" y "Seleccione" en el Select:
            state.tiposCervezas.unshift({
                tipoid: 0,
                tipo: 'Todas'
            });
            state.tiposCervezas.unshift({
                tipoid: -1,
                tipo: 'Seleccione'
            });
        },
        cleanWineList(state) {
            state.vinos = [];
            state.selectedWineIndex = -1;
            state.vino = {
                vinoid: 0,
                nombre: "",
                bodega: "",
                tipo: "",
                pais: "",
                region: "",
                uva: "",
                descripcion: "",
                notasdecata: "",
                imagen: "",
                rating: 0
            };
        },
        cleanLiquorList(state) {
            state.licores = [];
            state.selectedLiquorIndex = -1;
            state.licor = {
                licorid: 0,
                nombre: "",
                tipo: "",
                pais: "",
                descripcion: "",
                etiqueta: "",
                imagen: "",
                rating: 0
            };
        },
        cleanBeerList(state) {
            state.cervezas = [];
            state.selectedBeerIndex = -1;
            state.cerveza = {
                cervezaid: 0,
                nombre: "",
                tipo: "",
                pais: "",
                descripcion: "",
                etiqueta: "",
                imagen: "",
                rating: 0
            };
        },
        setVinos(state, vinos) {
            //Si no hay resultados en la búsqueda, el servidor regresa un arreglo con un solo elemento con vinoid = 0... 
            if ((vinos.length > 0) && (vinos[0].vinoid !== 0)) {
                state.bNoResults = false;
                state.vinos = vinos;
                state.selectedWineIndex = 0;
                state.vino = state.vinos[0];


                var i;
                for (i = 0; i < state.vinos.length; i++) {
                    if (state.vinos[i].imagen === "") //Imagen por default si el vino no tiene imagen:
                    {
                        state.vinos[i].imagen = require("@/assets/iconos/bottle-wine.png");
                    }
                    else {
                        state.vinos[i].imagen = require("@/assets/vinateria/" + state.vinos[i].imagen);
                    }

                }
            }
            else //No hubo resultados en la búsqueda...
            {
                state.bNoResults = true;
                state.vinos = [];
                state.selectedWineIndex = -1;

                state.vino = {
                    vinoid: 0,
                    nombre: "",
                    bodega: "",
                    tipo: "",
                    pais: "",
                    region: "",
                    uva: "",
                    descripcion: "",
                    notasdecata: "",
                    imagen: "",
                    rating: 0
                };
            }
        },
        setLicores(state, licores) {
            //Si no hay resultados en la búsqueda, el servidor regresa un arreglo con un solo elemento con licorid = 0... 
            if ((licores.length > 0) && (licores[0].licorid !== 0)) {
                state.bNoResults = false;
                state.licores = licores;
                state.selectedLiquorIndex = 0;
                state.licor = state.licores[0];

                var i;
                for (i = 0; i < state.licores.length; i++) {
                    if (state.licores[i].imagen === "") //Imagen por default si el licor no tiene imagen:
                    {
                        state.licores[i].imagen = require("@/assets/iconos/bottle-tonic.png");
                    }
                    else {
                        state.licores[i].imagen = require("@/assets/licoreria/" + state.licores[i].imagen);
                    }
                }
            }
            else //No hubo resultados en la búsqueda...
            {
                state.bNoResults = true;
                state.licores = [];
                state.selectedLiquorIndex = -1;

                state.licor = {
                    licorid: 0,
                    nombre: "",
                    tipo: "",
                    pais: "",
                    descripcion: "",
                    etiqueta: "",
                    imagen: "",
                    rating: 0
                };
            }
        },
        setCervezas(state, cervezas) {
            //Si no hay resultados en la búsqueda, el servidor regresa un arreglo con un solo elemento con cervezaid = 0... 
            if ((cervezas.length > 0) && (cervezas[0].cervezaid !== 0)) {
                state.bNoResults = false;
                state.cervezas = cervezas;
                state.selectedBeerIndex = 0;
                state.cerveza = state.cervezas[0];

                var i;
                for (i = 0; i < state.cervezas.length; i++) {
                    if (state.cervezas[i].imagen === "") //Imagen por default si la cerveza no tiene imagen:
                    {
                        state.cervezas[i].imagen = require("@/assets/iconos/glass-mug.png");
                    }
                    else {
                        state.cervezas[i].imagen = require("@/assets/cerveceria/" + state.cervezas[i].imagen);
                    }
                }
            }
            else //No hubo resultados en la búsqueda...
            {
                state.bNoResults = true;
                state.cervezas = [];
                state.selectedBeerIndex = -1;

                state.cerveza = {
                    cervezaid: 0,
                    nombre: "",
                    tipo: "",
                    pais: "",
                    descripcion: "",
                    etiqueta: "",
                    imagen: "",
                    rating: 0
                };
            }
        },
        setPlatillos(state, platillos) {
            //Si no hay resultados en la búsqueda, el servidor regresa un arreglo con un solo elemento con restauranteid = 0...

            if ((platillos.length > 0) && (platillos[0].restauranteid !== 0)) {
                state.bNoResults = false;
                state.platillos = platillos;

                var i;
                for (i = 0; i < state.platillos.length; i++) {
                    if (state.platillos[i].imagen === "") //Imagen por default si el platillo no tiene imagen:
                    {
                        state.platillos[i].imagen = require("@/assets/iconos/camera.png");
                        state.platillos[i].imagenblur = require("@/assets/iconos/camera.png");
                    }
                    else {
                        state.platillos[i].imagen = require("@/assets/restaurante/" + state.platillos[i].imagen);
                        state.platillos[i].imagenblur = require("@/assets/restaurante/" + state.platillos[i].imagenblur);
                    }
                }
            }
            else //No hubo resultados en la búsqueda...
            {
                state.bNoResults = true;
                state.platillos = [];
            }
        },
        setProductosGourmet(state, productos) {
            //Si no hay resultados en la búsqueda, el servidor regresa un arreglo con un solo elemento con productoid = 0... 
            if ((productos.length > 0) && (productos[0].productoid !== 0)) {
                state.bNoResults = false;
                state.productosGourmet = productos;

                var i;
                for (i = 0; i < state.productosGourmet.length; i++) {
                    if (state.productosGourmet[i].imagen === "") //Imagen por default si el producto no tiene imagen:
                    {
                        state.productosGourmet[i].imagen = require("@/assets/iconos/camera.png");
                    }
                    else {
                        state.productosGourmet[i].imagen = require("@/assets/gourmet/" + state.productosGourmet[i].imagen);
                    }
                }
            }
            else //No hubo resultados en la búsqueda...
            {
                state.bNoResults = true;
                state.productosGourmet = [];
            }
        },
        updateSelectedWineIndex: (state, index) => {
            state.selectedWineIndex = index;
        },
        updateSelectedLiquorIndex: (state, index) => {
            state.selectedLiquorIndex = index;
        },
        updateSelectedBeerIndex: (state, index) => {
            state.selectedBeerIndex = index;
        },
        updateVino: (state, vino) => {
            state.vino = vino;
        },
        updateLicor: (state, licor) => {
            state.licor = licor;
        },
        updateCerveza: (state, cerveza) => {
            state.cerveza = cerveza;
        },

    },
    actions: {
        updateAutorizado({ commit }, autorizado) {
            commit('setAutorizado', autorizado);
        },
        fetchPaises({ commit, state }) {
            state.bWaitCursor = true;

            axios.get('/paises/')
                .then(res => {
                    console.log("fetchPaises, paises = ", res.data);
                    state.bWaitCursor = false;
                    commit('setPaises', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        fetchTiposVinos({ commit, state }) {
            state.bWaitCursor = true;

            axios.get('/tipoVino/')
                .then(res => {
                    console.log("fetchTiposVinos, tipos = ", res.data);
                    state.bWaitCursor = false;
                    commit('setTiposVinos', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        fetchTiposLicores({ commit, state }) {
            state.bWaitCursor = true;

            axios.get('/tipoLicores/')
                .then(res => {
                    console.log("fetchTiposLicores, tipos = ", res.data);
                    state.bWaitCursor = false;
                    commit('setTiposLicores', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        fetchTiposCervezas({ commit, state }) {
            state.bWaitCursor = true;

            axios.get('/tipoCervezas/')
                .then(res => {
                    console.log("fetchTiposCervezas, tipos = ", res.data);
                    state.bWaitCursor = false;
                    commit('setTiposCervezas', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchWines({ commit, state }, winesQueryData) {
            state.bWaitCursor = true;
            //console.log("queryData: ", winesQueryData);

            axios.get('/vinos/' + winesQueryData.paisID + '/' + winesQueryData.tipoVinoID, { crossDomain: true })
                .then(res => {
                    console.log("fetchWiness, vinos = ", res.data);
                    state.bWaitCursor = false;
                    commit('setVinos', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
            // setTimeout(() => {
            //     state.bWaitCursor = false;
            //     console.log("Timer Finalizado");
            //     commit('setVinos', state.vinosTemp);
            // }, 2000);
        },
        fetchLiquors({ commit, state }, liquorsQueryData) {
            state.bWaitCursor = true;
            //console.log("queryData: ", liquorsQueryData);

            axios.get('/licores/' + liquorsQueryData.paisID + '/' + liquorsQueryData.tipoLicorID, { crossDomain: true })
                .then(res => {
                    console.log("fetchLiquors, licores = ", res.data);
                    state.bWaitCursor = false;
                    commit('setLicores', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        fetchBeers({ commit, state }, beersQueryData) {
            state.bWaitCursor = true;
            //console.log("queryData: ", beersQueryData);

            axios.get('/cervezas/' + beersQueryData.paisID + '/' + beersQueryData.tipoCervezaID, { crossDomain: true })
                .then(res => {
                    console.log("fetchBeers, cervezas = ", res.data);
                    state.bWaitCursor = false;
                    commit('setCervezas', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchRestaurante({ commit, state }) {
            state.bWaitCursor = true;

            axios.get('/restaurante/', { crossDomain: true })
                .then(res => {
                    console.log("fetchRestaurante, platillos = ", res.data);
                    state.bWaitCursor = false;
                    commit('setPlatillos', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        fetchProductosGourmet({ commit, state }) {
            state.bWaitCursor = true;

            axios.get('/gourmet/', { crossDomain: true })
                .then(res => {
                    console.log("fetchProductosGourmet, productos = ", res.data);
                    state.bWaitCursor = false;
                    commit('setProductosGourmet', res.data);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        cleanWineList({ commit }) {
            commit('cleanWineList');
        },
        cleanLiquorList({ commit }) {
            commit('cleanLiquorList');
        },
        cleanBeerList({ commit }) {
            commit('cleanBeerList');
        },
        updateSelectedWineIndex({ commit }, index) {
            commit('updateSelectedWineIndex', index);
        },
        updateSelectedLiquorIndex({ commit }, index) {
            commit('updateSelectedLiquorIndex', index);
        },
        updateSelectedBeerIndex({ commit }, index) {
            commit('updateSelectedBeerIndex', index);
        },
        updateVino({ commit }, vino) {
            commit('updateVino', vino);
        },
        updateLicor({ commit }, licor) {
            commit('updateLicor', licor);
        },
        updateCerveza({ commit }, cerveza) {
            commit('updateCerveza', cerveza);
        },
        updateNoResults({ commit }, payload) {
            commit('setNoResults', payload)
        }
    },
    getters: {
        version: state => {
            return state.version;
        },
        autorizado: state => {
            return state.bAutorizado;
        },
        navAppTitle: state => {
            return state.navAppTitle;
        },
        navMainLogo: state => {
            return state.navMainLogo;
        },
        waitCursor: state => {
            return state.bWaitCursor;
        },
        noResults: state => {
            return state.bNoResults;
        },
        paises: state => {
            return state.paises;
        },
        tiposVinos: state => {
            return state.tiposVinos;
        },
        tiposLicores: state => {
            return state.tiposLicores;
        },
        tiposCervezas: state => {
            return state.tiposCervezas;
        },
        vinos: state => {
            return state.vinos;
        },
        licores: state => {
            return state.licores;
        },
        cervezas: state => {
            return state.cervezas;
        },
        selectedWineIndex: state => {
            return state.selectedWineIndex;
        },
        selectedLiquorIndex: state => {
            return state.selectedLiquorIndex;
        },
        selectedBeerIndex: state => {
            return state.selectedBeerIndex;
        },
        vino: state => {
            return state.vino;
        },
        licor: state => {
            return state.licor;
        },
        cerveza: state => {
            return state.cerveza;
        },
        platillos: state => {
            return state.platillos;
        },
        productosGourmet: state => {
            return state.productosGourmet;
        }
    }

});
